import { NgClass, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterConfigOption, FilterSelected } from '@scalefast/core';

@Component({
  selector: 'app-radio-select',
  styleUrls: ['./radio-select.component.scss'],
  templateUrl: './radio-select.component.html',
  standalone: true,
  imports: [NgClass, ReactiveFormsModule, FormsModule, TitleCasePipe],
})
export class AppRadioSelectComponent implements OnInit {
  @Input() list: any;
  @Input() name = '';
  @Output() shareValueSelected = new EventEmitter<any>();

  selectedOption: any;
  selectedOptionLabel = '';
  filterValues: any;

  ngOnInit(): void {
    this.loadActiveValues();
  }

  loadActiveValues() {
    this.list.map((item: any) => {
      if (item.checked) {
        this.selectedOption = item.value;
        this.selectedOptionLabel = item.label;
      }
    });
  }

  getSelectedValue(option: any) {
    this.selectedOption = option.value;
    this.selectedOptionLabel = option.label;
    this.list.map((item: any) => {
      if (item.value !== option.value) {
        item.checked = false;
      }
    });
    option.checked = true;
    this.shareSelectedValue();
  }

  shareSelectedValue() {
    this.shareValueSelected.emit([{ label: this.selectedOptionLabel, value: [this.selectedOption] }]);
  }
}
